import { WINDOW_LOAD } from "../actions/windowEvents";

export default (window) => {
    let windowOnLoadListener = null;
    return {
        onLoad
    }

    function onLoad(store, next, action) {
        if (!window) {
            return next(action);
        }
        const { common: { window: {isLoaded = false } = {} } = {} } = store.getState();
        if (!isLoaded && windowOnLoadListener === null) {
            //check document ready state
            if (window.document.readyState === "complete") {
                store.dispatch({ type: WINDOW_LOAD });
                return next(action);
            }
            //add event listener
            windowOnLoadListener = window.addEventListener("load", () => {
                store.dispatch({ type: WINDOW_LOAD });
            })
        }
        if(isLoaded && windowOnLoadListener !== null) {
            //remove event listener
            window.removeEventListener("load", windowOnLoadListener)
        }
        return next(action);
    }
}



// WEBPACK FOOTER //
// ./modules/Common/middleware/windowEvents.js